import React, { useEffect } from 'react';
import { Typography, Container, Grid, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Header from '../Header/Header';
import AddBeableAdminModal from './Modals/AddBeableAdminModal';
import DeleteBeableAdminModal from './Modals/DeleteBeableAdminModal';
import beableAdminService from '../../services/BeableAdminService';
import authService from '../../services/AuthService'
import { BeableAdminDTO } from "@beable/roster-backend-client-v1";
import BasePanel from '../Common/Layout/BasePanel';
import { BasePanelBox } from '../Common/Layout/BasePanelBox';
import BaseSheet from '../Common/Layout/BaseSheet';
import { StyledPanelHeader } from '../Common/Layout/PanelHeader';
import { useTheme } from '@mui/material/styles';
import { getStyles } from './styles';

const emptySelectedAdmin: BeableAdminDTO = {
    username: '',
    id: '1',
    firstName: '',
    lastName: ''
};

const initialAdminsValue: BeableAdminDTO[] = [];

export default function StaffManagement() {
    const theme = useTheme();
    const styles = getStyles(theme);
    const [selectedAdmin, setSelectedAdmin] = React.useState(emptySelectedAdmin);
    const [openAddAdminModal, setOenAddAdminModal] = React.useState(false);
    const [openDeleteAdminModal, setOpenDeleteAdminModal] = React.useState(false);
    const [shouldFetchAdmins, setShouldFetchAdmins] = React.useState(true);
    const [adminListItems, setAdminListItems] = React.useState(initialAdminsValue);
    const [profile] = React.useState(authService.getUser());

    const openAddModal = () => setOenAddAdminModal(true);
    const closeAddAdminModal = () => {
        setOenAddAdminModal(false);
        setShouldFetchAdmins(!shouldFetchAdmins);
    }
    const openDeleteModal = () => setOpenDeleteAdminModal(true);
    const closeDeleteModal = (deleted?: boolean) => {
        setOpenDeleteAdminModal(false);
        setShouldFetchAdmins(!shouldFetchAdmins);
        if (deleted) setSelectedAdmin(emptySelectedAdmin);
    }
    const handleTableRowClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
        if (e) {
            e.persist();
        }
        e.stopPropagation();
        const selectedRow = e.currentTarget;
        const selAdmin = adminListItems.find(administrator => administrator.id === selectedRow.id);
        if (selAdmin && selAdmin.id !== selectedAdmin.id) {
            setSelectedAdmin(selAdmin);
        } else {
            setSelectedAdmin(emptySelectedAdmin);
        }
    }

    useEffect(() => {
      const getBeableAdmins = async () => {
        const beableAdmins = await beableAdminService.getBeableAdmins();

        if(beableAdmins) {
          setAdminListItems(beableAdmins);
        }
      }
      getBeableAdmins();
    }, [shouldFetchAdmins]);

    return (
        <>
            <Header />
            <Grid container>
              <BasePanel>
                <BasePanelBox>
                  <StyledPanelHeader header="Staff Management" />
                  <Grid container size={12}>
                      <Typography variant="h5" sx={{ margin: '16px' }}>General Options</Typography>
                      <Container sx={styles.dfb}>
                          <Button sx={styles.verticalBtn} variant="contained" color="primary" onClick={openAddModal}>Add new beable admin</Button>
                      </Container>
                      {selectedAdmin.username !== '' ? (
                          <>
                              <Typography variant="h5">Options {selectedAdmin.username !== '' ? `for ${selectedAdmin.username}` : ''}</Typography>
                              <Container sx={styles.dfb}>
                                  <>
                                  {profile && profile.id !== selectedAdmin.id ? <Button
                                      sx={[styles.verticalBtn, styles.plainBtn]}
                                      variant="contained"
                                      onClick={openDeleteModal}>Delete admin</Button> : undefined}
                                  </>
                              </Container>
                          </>
                      ) : undefined}
                  </Grid>
                </BasePanelBox>
              </BasePanel>
              <BaseSheet>
                  <Grid size={12}>
                      <Typography align-left='true' sx={{
                          marginBottom: "16px"
                      }}>Use this page to manage beable admins.</Typography>
                      <Container sx={styles.dfb}>
                          <TableContainer component={Paper}>
                              <Table sx={styles.table} aria-label="admin data table">
                                  <TableHead>
                                      <TableRow>
                                          <TableCell align="left">Username</TableCell>
                                          <TableCell align="left">First Name</TableCell>
                                          <TableCell align="left">Last Name</TableCell>
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {adminListItems.map(admin => (
                                          <TableRow sx={selectedAdmin.id === admin.id ? styles.highlight : undefined} id={admin.id} key={admin.id} onClick={handleTableRowClick}>
                                              <TableCell component="th" scope="row">
                                                  {admin.username}
                                              </TableCell>
                                              <TableCell align="left">{admin.firstName}</TableCell>
                                              <TableCell align="left">{admin.lastName}</TableCell>
                                          </TableRow>
                                      ))}
                                  </TableBody>
                              </Table>
                          </TableContainer>
                      </Container>
                  </Grid>
              </BaseSheet>
            </Grid >
            <AddBeableAdminModal open={openAddAdminModal} handleClose={closeAddAdminModal} />
            {openDeleteAdminModal ? <DeleteBeableAdminModal open={openDeleteAdminModal} handleClose={closeDeleteModal} profile={selectedAdmin} /> : undefined}
        </>
    );
}